import { Lesson, LessonRequest } from "../../models/Lesson";
import { Module } from "../../models/Module";
import { Paged } from "../../models/Paged";
import { slavtHTTP } from "../http";

export function getLessonDetails(lessonId: string) {
  return slavtHTTP
    .get<Lesson>(`/lessons/${lessonId}`)
    .then(({ data }) => data)
    .catch((e) => {
      throw e;
    });
}

export function getModules() {
  return slavtHTTP
    .get<Paged<Module>>("/modules")
    .then(({ data }) => data)
    .catch((e) => {
      throw e;
    });
}

export function createLesson(learningPathId: string, lesson: LessonRequest) {
  return slavtHTTP
    .post<{ id: number }>(`/learning-paths/${learningPathId}/lessons`, lesson)
    .then(({ data }) => data)
    .catch((e) => {
      throw e;
    });
}

export function editLesson(lesson: LessonRequest) {
  return slavtHTTP
    .patch<{ id: number }>(`/lessons/${lesson.id}`, lesson)
    .then(({ data }) => data)
    .catch((e) => {
      throw e;
    });
}

export function deleteLesson(lessonId: string) {
  return slavtHTTP
    .delete<void>(`/lessons/${lessonId}`)
    .then(({ data }) => data)
    .catch((e) => {
      throw e;
    });
}
